import React from 'react';
import { Provider } from 'react-redux';
import createStore from './src/store';
import { ThemeProvider } from '@dls/web';
import Theme from '@/theme';
import Layout from '@/components/Layout';
import './styles.css';
import '@dls/web/assets/fonts.css';

const { store } = createStore;

const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <Layout>{element}</Layout>
      </ThemeProvider>
    </Provider>
  );
};

export default wrapRootElement;
